<div class="cursor-pointer" *ngIf="hasCoordinate()" style="width: 100%; height: 300px;">
  <google-map
    #myMap="googleMap"
    mapId="show-maps"
    [center]="center()"
    [zoom]="zoom"
    [options]="options"
    width="100%"
    height="200%"
  >
    <map-advanced-marker *ngIf="hasCoordinate() !== null" [position]="coordinate()!"/>
 
  </google-map>
</div>
<div class="flex justify-content-between gap-2">
  <app-text-field label="Lat" [value]="coordinate()?.lat ?? '---'" textSize="xs"></app-text-field>
  <app-text-field label="Lng" [value]="coordinate()?.lng ?? '---'" textSize="xs"></app-text-field>
  <app-text-field label="Alt" [value]="coordinate()?.altitude ?? '---'" textSize="xs"></app-text-field>
</div>
